// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Content from './content';
import { _ } from "~/i18n";

/**
 * @class Vytváří odkazy na detailní informace k obsahu vizitky z různých zdrojů
 * @private
 */
 export default class Infolinks extends Content {
	_build() {
		this._dom.container.classList.add("content-infolinks");

		/* muze prijit jen v XML; ve frpc to bude vzdy link */
		for(var i = 0; i < this._data.length; i++){
			var text = this._getTextFromUrl(this._data[i].url);
			var line = JAK.cel("p");
			var link = node("a", {target:"_blank",href:this._data[i].url});
			link.innerHTML = text;
			line.appendChild(link);
			this._dom.container.appendChild(line);
		}
	}

	_getTextFromUrl(url) {
		var m = url.match(/\/\/([^\/\?\#]+)/);
		var out = m && m.length >= 2 ? m[1] : url;
		return _("moreInfo") + " " + out + " &raquo;";
	}
}
